import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-basel-country-report',
  templateUrl: './basel-country-report.component.html',
  styleUrls: ['./basel-country-report.component.scss']
})
export class BaselCountryReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
